import http from "@/http/aisea/axios";
const resource = "/../secure_dataflow/m0";

export default {

    getCheckListRooms(vesselId, versionId) {
        return http.get(`${resource}/vessels/${vesselId}/rooms/versions/${versionId}`);
    },

}
